import type { FunctionComponent, ReactNode } from 'react';
import { useMemo, useReducer } from 'react';

import EnvCropsOrdersContext from './EnvCropsOrdersContext';
import { getActions } from './actions';
import { initialState, reducer } from './reducer';

const EnvCropsOrdersProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const actions = useMemo(() => getActions(dispatch), [dispatch]);

  return (
    <EnvCropsOrdersContext.Provider value={{ actions, state }}>
      {children}
    </EnvCropsOrdersContext.Provider>
  );
};

export default EnvCropsOrdersProvider;
